import ServerRequestUtil from '../utils/ServerRequestUtil';

export default new class {

    // 新Forthing2 API エンドポイント
    async getForthingDetail() {
        return ServerRequestUtil.get('/api/app/aube-coin/forthing/detail');
    }

    // 最新の取引を取得（デフォルトで10件）
    async getForthingLatestTransactions() {
        return ServerRequestUtil.get('/api/app/aube-coin/forthing/transactions', { per_page: 10, page: 1 });
    }

    // ページネーション付き取引履歴
    async getForthingTransactions(data) {
        return ServerRequestUtil.get('/api/app/aube-coin/forthing/transactions', {...data});
    }

    // EX ボーナス実績トランザクション履歴取得
    async getExBonusTransactions(data) {
        return ServerRequestUtil.get('/api/app/aube-coin/exbonus/transactions', {...data});
    }
}